import { OptimisticPatch } from '../CollectionOptimisticPatch';
import { trimAddedItemsFromPagePredicate } from './trimAddedItemsFromPagePredicate';

export interface OrderByMovesParams<T> {
  pageWithPatchedItems: { item: T; orderByItem?: T }[];
  patches: OptimisticPatch<T>[];
  pageIndex: number;
  currentFiltersKeyHash: string;
  itemKey: (item: T) => string;
  toMerge: {
    all: Map<string, { item: T; keepPosition?: boolean }>;
    created: Map<string, { item: T; keepPosition?: boolean }>;
  };
  itemPredicate: (item: T) => boolean;
  limit: number;
}

export function orderByMoves<T>(params: OrderByMovesParams<T>): T[] {
  const {
    pageWithPatchedItems,
    patches,
    currentFiltersKeyHash,
    itemKey,
    pageIndex,
    toMerge,
    limit,
  } = params;
  const newPage = pageWithPatchedItems
    .map(({ item }) => item)
    .filter(
      trimAddedItemsFromPagePredicate({
        addedItems: toMerge.all,
        itemKey,
        limit,
      }),
    );

  for (const { move } of patches) {
    if (move == null || move.filtersKeyHash !== currentFiltersKeyHash) {
      continue;
    }

    const fromKey = move.from.key;
    const toKey = move.after?.key;

    const fromIndex = newPage.findIndex((item) => fromKey === itemKey(item));
    if (fromIndex !== -1) {
      move.from.item = newPage[fromIndex];
      newPage.splice(fromIndex, 1);
    }

    if (toKey != null) {
      const toIndex = newPage.findIndex((item) => toKey === itemKey(item));
      if (toIndex !== -1) {
        newPage.splice(toIndex + 1, 0, move.from.item);
      }
    } else if (pageIndex === 0) {
      newPage.splice(0, 0, move.from.item);
    }
  }

  return newPage;
}
